<template>
    <v-navigation-drawer
        app
        clipped
        :mobile-breakpoint="600">

        <v-list
            expand>
            <template
                v-for="(menu, index) in sideMenuList">
                <v-list-group
                    v-if="menu.children"
                    v-model="expandListGroupDict[menu.id]"
                    color="grey"
                    :key="index">
                    <template v-slot:activator>
                        <icon
                            :class="[ getItemActiveClass(menu) ]"
                            :value="menu.icon"
                            :size="$constant.SIDEMENU_ICON_SIZE"/>
                        <div
                            class="list-group-header ml-4"
                            :class="[ getItemActiveClass(menu) ]">
                            {{ menu.name }}
                        </div>
                    </template>

                    <template v-for="(subMenu, index) in menu.children">
                        <v-list-item
                            :class="[ getMenuActiveClass(subMenu) ]"
                            :key="index"
                            @click="executeActionMenu(subMenu)">
                            &emsp;
                            <icon
                                :class="[ getItemActiveClass(subMenu) ]"
                                :value="subMenu.icon"
                                :size="$constant.SIDEMENU_ICON_SIZE"/>
                            <div
                                :class="[ getItemActiveClass(subMenu) ]">
                                {{ subMenu.name }}
                            </div>
                        </v-list-item>
                    </template>
                </v-list-group>
                <v-list-item
                    v-else
                    :class="[ getMenuActiveClass(menu) ]"
                    :key="index"
                    @click="executeActionMenu(menu)">
                    <icon
                        class="mr-4"
                        :class="[ getItemActiveClass(menu) ]"
                        :value="menu.icon"
                        :size="$constant.SIDEMENU_ICON_SIZE"/>
                    <div
                        :class="[ getItemActiveClass(menu) ]">
                        {{ menu.name }}
                    </div>
                </v-list-item>
            </template>
        </v-list>
    </v-navigation-drawer>
</template>

<script>
export default {
    name: 'SideMenuBar',

    data () {
        //  adding side menu here
        //  base menu should in this structure
        //      - name
        //      - icon
        //      - routeOption
        //  If the menu has subMenu, adding children and menuItem
        //  then it no need for routeOption
        const availableSideMenu = [
            {
                name: this.$t('menu.bookingList'),
                value: 'BookingList',
                icon: 'hero_ClipboardList',
                action: {
                    name: 'goToMenu',
                    args: [
                        {
                            name: 'BookingList'
                        }
                    ]
                }
            },
            // {
            //     name: this.$t('menu.ticketAndAddOns'),
            //     value: 'TicketAndAddOn',
            //     icon: 'hero_Ticket',
            //     action: {
            //         name: 'goToMenu',
            //         args: [
            //             {
            //                 name: 'TicketAndAddOn'
            //             }
            //         ]
            //     }
            // },
            {
                name: this.$t('menu.andamandaPay'),
                value: 'AndamandaPay',
                icon: 'hero_Qrcode',
                action: {
                    name: 'goToMenu',
                    args: [
                        {
                            name: 'AndamandaPay'
                        }
                    ]
                }
            },
            {
                name: this.$t('menu.ticketVisibility'),
                value: 'TicketVisibility',
                icon: 'hero_Ticket',
                action: {
                    name: 'goToMenu',
                    args: [
                        {
                            name: 'TicketVisibility'
                        }
                    ]
                }
            },
            {
                name: this.$t('menu.homepageSetting'),
                icon: 'hero_Home',
                children: [
                    {
                        name: this.$t('menu.topBanners'),
                        value: 'TopBannerSetting',
                        action: {
                            name: 'goToMenu',
                            args: [
                                {
                                    name: 'TopBannerSetting'
                                }
                            ]
                        }
                    },
                    {
                        name: this.$t('menu.promotions'),
                        value: 'PromotionSetting',
                        action: {
                            name: 'goToMenu',
                            args: [
                                {
                                    name: 'PromotionSetting'
                                }
                            ]
                        }
                    }
                ]
            },
            {
                name: this.$t('menu.ibeaconSetting.title'),
                icon: 'hero_Wifi',
                children: [
                    {
                        name: this.$t('menu.ibeaconSetting.messages'),
                        value: 'IBeaconMessageList',
                        icon: '',
                        action: {
                            name: 'goToMenu',
                            args: [
                                {
                                    name: 'IBeaconMessageList'
                                }
                            ]
                        }
                    },
                    {
                        name: this.$t('menu.ibeaconSetting.setting'),
                        value: 'IBeaconList',
                        icon: '',
                        action: {
                            name: 'goToMenu',
                            args: [
                                {
                                    name: 'IBeaconList'
                                }
                            ]
                        }
                    }
                ]
            },
            {
                name: this.$t('menu.teamBuilding.title'),
                icon: 'hero_Puzzle',
                action: {
                    name: 'goToUrl',
                    args: [
                        process.env.VUE_APP_TEAM_BUILDING_URL,
                        true
                    ]
                }
                // children: [
                //     {
                //         name: this.$t('menu.teamBuilding.events'),
                //         icon: '',
                //         action: {
                //             name: 'goToMenu',
                //             args: [
                //                 {
                //                     name: 'EventList'
                //                 }
                //             ]
                //         }
                //     },
                //     {
                //         name: this.$t('menu.teamBuilding.customer'),
                //         icon: '',
                //         action: {
                //             name: 'goToMenu',
                //             args: [
                //                 {
                //                     name: 'CustomerGroupList'
                //                 }
                //             ]
                //         }
                //     },
                //     {
                //         name: this.$t('menu.teamBuilding.participants'),
                //         icon: '',
                //         action: {
                //             name: 'goToMenu',
                //             args: [
                //                 {
                //                     name: 'ParticipantList'
                //                 }
                //             ]
                //         }
                //     },
                //     {
                //         name: this.$t('menu.teamBuilding.staff'),
                //         icon: '',
                //         action: {
                //             name: 'goToMenu',
                //             args: [
                //                 {
                //                     name: 'StaffList'
                //                 }
                //             ]
                //         }
                //     }
                // ]
            },
            {
                name: this.$t('menu.treasureHunt'),
                value: 'TreasureHunt',
                icon: 'hero_Puzzle',
                action: {
                    name: 'goToMenu',
                    args: [
                        {
                            name: 'TreasureHunt'
                        }
                    ]
                }
            },
            {
                name: this.$t('menu.saleAgentRequest'),
                value: 'SaleAgentRequest',
                icon: 'hero_UserAdd',
                action: {
                    name: 'goToMenu',
                    args: [
                        {
                            name: 'SaleAgentRequest'
                        }
                    ]
                }
            },
            {
                name: this.$t('menu.saleAgent.title'),
                icon: 'hero_Users',
                children: [
                    {
                        name: this.$t('menu.saleAgent.byCategory'),
                        value: 'SaleAgentByCategory',
                        action: {
                            name: 'goToMenu',
                            args: [
                                {
                                    name: 'SaleAgentByCategory'
                                }
                            ]
                        }
                    },
                    {
                        name: this.$t('menu.saleAgent.byPersons'),
                        value: 'SaleAgentByPerson',
                        action: {
                            name: 'goToMenu',
                            args: [
                                {
                                    name: 'SaleAgentByPerson'
                                }
                            ]
                        }
                    }
                ]
            },
            {
                name: this.$t('menu.andamandaStaff'),
                value: 'AndamandaStaffList',
                icon: 'hero_Users',
                action: {
                    name: 'goToMenu',
                    args: [
                        {
                            name: 'AndamandaStaffList'
                        }
                    ]
                }
            },
            {
                name: this.$t('menu.customerList'),
                value: 'CustomerList',
                icon: 'hero_Star',
                action: {
                    name: 'goToMenu',
                    args: [
                        {
                            name: 'CustomerList'
                        }
                    ]
                }
            }
        ]

        //  create sideMenu
        const sideMenuList = this.initSideMenuList(availableSideMenu)

        //  create dict of menu(hasSubmenu) id to visible value
        const expandListGroupDict = sideMenuList.reduce((result, current) => {
            if (current?.children?.length > 0) {
                result[current.id] = this.getExpandListGroupVisible(current)
            }
            return result
        }, {})

        //  create observable data
        return {
            expandListGroupDict,
            sideMenuList
        }
    },

    methods: {
        /**
         * This function for initialize sideMenuList
         *  - adding sequence number to be an id
         * @param {Object} sideMenuList
         * @param {Number} startId
         * @returns {null}
         */
        initSideMenuList (sideMenuList, startId = 1) {
            //  create function to adding id to menu item
            const addingIdToMenuList = (menuList, iterationCount) => {
                const addedIdToMenuList = menuList.map(menu => {
                    const addedIdToMenu = {
                        ...menu,
                        id: iterationCount
                    }

                    iterationCount++

                    if (menu?.children) {
                        return {
                            ...addedIdToMenu,
                            children: addingIdToMenuList(menu.children, iterationCount)
                        }
                    }

                    return addedIdToMenu
                })

                return addedIdToMenuList
            }

            return addingIdToMenuList(sideMenuList, startId)
        },

        /**
         * This function will execute menu action
         * @param {Object} menuItem require action object with name and args
         */
        executeActionMenu (menuItem) {
            const actionName = menuItem?.action?.name ?? ''
            const args = menuItem?.action?.args ?? []

            // eslint-disable-next-line
            this[actionName]?.(...args)
        },

        /**
         * This function for navigate to url
         * @param {String} url
         */
        goToUrl (url, openNewTab = false) {
            if (openNewTab) {
                window.open(url)
            } else {
                window.location = url
            }
        },

        /**
         * This function is for navigating to menuItem route
         * It will ignore operation if current location same to destination
         * @param {Object} routeOption
         */
        goToMenu (routeOption) {
            if (this.$route.name !== routeOption?.name) {
                this.$router.push(routeOption)
            }
        },

        /**
         * This function is for checking is the menu same to current active
         * @param {Object} menuItem require routeOption
         * @returns {Boolean}
         */
        isActiveMenu (menuItem) {
            return menuItem?.value === this.$route.name
        },

        /**
         * The expand group that we use need to bind to our data
         * In this context we map the group item into dict by id
         * Thus, this function will find visible value of each group item
         * @param {Object} groupItem
         * @return {Boolean}
         */
        getExpandListGroupVisible (groupItem) {
            return groupItem?.children?.some(item => this.isActiveMenu(item))
        },

        /**
         * getting html class of menu item for each menu state
         * @param {Object} menuItem
         * @return {String}
         */
        getItemActiveClass (menuItem) {
            const inactiveStyle = 'font-weight-light grey--text text--darken-1'
            const activeStyle = 'accentLight accent--text font-weight-bold'

            return this.isActiveMenu(menuItem) ? activeStyle : inactiveStyle
        },

        /**
         * getting html class of menu for each menu state
         * @param {Object} menuItem
         * @return {String}
         */
        getMenuActiveClass (menuItem) {
            const inactiveStyle = 'font-weight-light grey--text text--darken-1'
            const activeStyle = 'accentLight accent--text menu-active'

            return this.isActiveMenu(menuItem) ? activeStyle : inactiveStyle
        }
    }
}
</script>

<style lang="scss" scoped>
::v-deep .v-list-item {
    text-transform: none;

    .v-list-item__icon {
        margin-left: 0px !important;
    }
}

.list-group-header {
    min-width: 120px;
}

.menu-active {
    border-right: 5px solid #FAAD14 !important;
}

.expand-icon {
    position: absolute;
    right: 16px;
}
</style>
